import '../styles/basic.css';

export function Button(props: {label ?: string, img ?: string, onClick: any}) {

  const label = props.label != undefined ? props.label : null;
  const img = props.img !== undefined ? <img src={props.img} /> : null;

  return (
    <button className='basic-button' onClick={props.onClick}>{label}{img}</button>
  );
}